'use client';

import StarRating from 'components/gruenland/molecules/ratings/StarRating';
import { useFormat } from 'helpers/hooks/useFormat';
import useAverageRatings from './hooks/useAverageRatings';

const AverageRatings: React.FC = () => {
  const averageRatings = useAverageRatings();
  const { formatMessage } = useFormat({ name: 'gruenland' });
  if (!averageRatings.rating) return null;
  return (
    <div className="flex w-full flex-wrap items-center gap-4">
      <StarRating rating={averageRatings.rating} color="white" className="hidden sm:block" />
      <p className="text-[18px]/[22.68px] font-extrabold">{averageRatings.rating}/5</p>
      <p>
        {formatMessage({
          id: 'feedaty.average',
          defaultMessage: 'Valutazione media Feedaty su {count} recensioni',
          values: { count: averageRatings.count },
        })}
      </p>
    </div>
  );
};

export default AverageRatings;
